import { Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../translations';

import { VisitHistoryPatientPregnancyMark } from './VisitHistoryPatientPregnancyMark';

type VisitHistoryInterviewItemHeadingProps = {
   readonly patientPregnant: boolean;
};

export const VisitHistoryInterviewItemHeading = (props: VisitHistoryInterviewItemHeadingProps): JSX.Element => {
   return (
      <StyledFlex justifyContent={'space-between'}>
         <Translate>{visitHistoryTranslationKeys.interview}</Translate>
         {props.patientPregnant ? <VisitHistoryPatientPregnancyMark /> : null}
      </StyledFlex>
   );
};
